var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "partners",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect8872",
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g939",
    transform: "translate(3.383 2.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M16.367,20.344a5.56,5.56,0,0,1-5.8-5.8,5.56,5.56,0,0,1,5.8-5.8,5.56,5.56,0,0,1,5.8,5.8,5.56,5.56,0,0,1-5.8,5.8ZM4,32.75V29.117a4.5,4.5,0,0,1,.676-2.435,4.356,4.356,0,0,1,1.952-1.662,28.312,28.312,0,0,1,5.159-1.778,20.62,20.62,0,0,1,4.58-.541h.889a6.011,6.011,0,0,0-.348,1.063,11.386,11.386,0,0,0-.193,1.256h-.348a19.9,19.9,0,0,0-4.386.483,20.058,20.058,0,0,0-4.425,1.6,2.1,2.1,0,0,0-.928.87,2.335,2.335,0,0,0-.309,1.14v1.314h10.4a7.514,7.514,0,0,0,.464,1.256,6.062,6.062,0,0,0,.657,1.063ZM16.367,18.025a3.371,3.371,0,0,0,3.478-3.478,3.371,3.371,0,0,0-3.478-3.478,3.371,3.371,0,0,0-3.478,3.478,3.371,3.371,0,0,0,3.478,3.478Z",
    transform: "translate(-4 -8.75)",
    fill: "rgba(0,0,0,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M7.778,55.5a.336.336,0,0,1-.408.245L6.1,55.433a.677.677,0,0,1-.278-.145l-.949-.825a.337.337,0,0,1,.442-.508l.949.825,1.268.317A.336.336,0,0,1,7.778,55.5ZM13.356,51.5a.668.668,0,0,1-.339.395l-.979.489-.629.736-.007.007-.006.007,0,.005L9.843,54.685a.677.677,0,0,1-.477.2.667.667,0,0,1-.162-.02l-2.438-.61a.669.669,0,0,1-.251-.123L4.242,52.353l-1.01-.5a.673.673,0,0,1-.3-.914l1.035-1.981a.676.676,0,0,1,.9-.29l.941.471,2.047-.6a.674.674,0,0,1,.466.033l1.388.628H10.4l.979-.49a.676.676,0,0,1,.9.29l1.035,1.981a.668.668,0,0,1,.044.519ZM10.637,52.94l-1.331-.968-.34.255a1.691,1.691,0,0,1-2.019,0l-.228-.171a.673.673,0,0,1-.072-1.014l1.646-1.646a.682.682,0,0,1,.077-.065l-.324-.147L6,49.78,4.851,51.974,6.929,53.6l2.438.61Zm.786-.874-1.147-2.2H8.769L7.122,51.517l.228.171a1.015,1.015,0,0,0,1.212,0l.538-.4a.336.336,0,0,1,.4,0l1.6,1.163Z",
    transform: "translate(10.039 -32.484)",
    fill: "rgba(0,0,0,0.6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/Partners.b2db8bbc62466dac74e192ed792c3eac.svg";
export { ForwardRef as ReactComponent };